import { Input } from "antd"
import style from "./NameSection.module.scss"

const { section, labelRow, label, requiredMark, textInput } = style

type Props = {
	value: string
	onChange: (value: string) => void
	onBlur?: () => void
}

export const NameSection = ({ value, onChange, onBlur }: Props) => {
	return (
		<div className={section}>
			<div className={labelRow}>
				<span className={label}>Name</span>
				<span className={requiredMark}>*</span>
			</div>
			<Input
				className={textInput}
				value={value}
				onChange={(e) => onChange(e.target.value)}
				onBlur={onBlur}
				maxLength={255}
			/>
		</div>
	)
}
